module.exports = __webpack_public_path__ + "static/brick-brand-a38ddf7c12a6513bafaf121fd577c5d8.jpg";